"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getURL = getURL;
exports.getLocale = getLocale;
exports.getTimestamp = getTimestamp;
exports.setReferrerCookie = setReferrerCookie;
exports.setSearchParamsCookie = setSearchParamsCookie;

var _cookies = _interopRequireDefault(require("./lib/cookies"));

var _queryString = _interopRequireWildcard(require("./queryString"));

var constants = _interopRequireWildcard(require("./constants"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the current url from the window
 * @return {String}
 */
function getURL() {
  if (window && window.location) return window.location.href;
}
/**
 * Returns the current locale from the user agent
 * @return {String}
 */


function getLocale() {
  return navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
}
/**
 * Returns the the current date as ISO
 * @return {String}
 */


function getTimestamp() {
  return new Date().toISOString();
}
/**
 * Sets the we referrer cookie
 */


function setReferrerCookie() {
  if (!_cookies.default.getItem('we_referring_domain')) {
    const we_referring_domain = document.referrer || '';

    _cookies.default.setItem('we_referring_domain', we_referring_domain);
  }
}
/**
 * Sets the we referrer cookie
 */


function setSearchParamsCookie() {
  const searchMap = (0, _queryString.default)();
  const mergedSearchMap = (0, _queryString.mergeSearchParamsWithCurrentCookie)(searchMap);

  _cookies.default.setItem(constants.SEARCH_PARAMS_COOKIE_KEY, JSON.stringify(mergedSearchMap));
}